define('shared/util/tracking/dailyLesson',['$', 'shared/lib/RSVP', 'shared/lib/console', 'shared/initializer/form/constants'], function($, RSVP, console, constants){

    'use strict';

    function checkedOrValueTrue($parent, elementName){
        if(!$parent || $parent.length === 0){
            return false;
        }

        var $elem = getElementByName($parent, elementName);
        if(!$elem || $elem.length === 0){
            return false;
        }

        if($elem.is(':checkbox')){
            return $elem.is(':checked');
        }
        else {
            return $elem.val() === 'true';
        }
    }

    function getElementByName($parent, elementName){
        return $parent.find('[name=\'' + elementName + '\']');
    }

    return {
        dailyLessonSubscribed: function(){
            var me = this;

            if(
                checkedOrValueTrue(me.$form, constants.FIELD.MemberSubscribeToEmailEnglish) || 
                checkedOrValueTrue(me.$form, constants.FIELD.MemberSubscribeToDailyLesson)
            ){
                return true;
            }

            var $englishEmailField = getElementByName(me.$form, constants.FIELD.EnglishEmail);
            if($englishEmailField.length === 0)
                $englishEmailField = getElementByName(me.$form, constants.FIELD.EmailEnglish);

            if ($englishEmailField.length > 0) {
                if($englishEmailField.is(':checkbox')){
                    return $englishEmailField.is(':checked');
                }
                else if($englishEmailField.val() === 'true'){
                    var $emailListField = getElementByName(me.$form, constants.FIELD.EmailList);
                    if($emailListField.val() && $emailListField.val().indexOf('17') >= 0){
                        return true;
                    }
                }
            }

            return false;

        }
    };
});
